export default __webpack_public_path__ + "static/media/Rooftop-Terrace.de2aa61a.webp";